export default {
  upload: {
    dropFiles: 'Solte os arquivos aqui para fazer o upload',
    delete: 'Excluir',
    deleteAllConfirm: 'Tem certeza de que deseja excluir todos os arquivos?',
    deleteConfirm: 'Tem certeza de que deseja excluir {filename}?',
    deleteAllSuccess: 'Todos os arquivos excluídos com sucesso!',
    deleteSuccess: '{filename} excluído com sucesso!',
    deleteCancelled: 'Exclusão cancelada',
    warning: 'Aviso',
    cancel: 'Cancelar',
    fileSize: 'Tamanho: {size} KB'
  },
  test: {
    title: 'Vista de teste de i18n',
    description: 'Esta é uma vista de teste para demonstrar as capacidades de i18n.',
    item1: 'Primeiro item',
    item2: 'Segundo item',
    item3: 'Terceiro item'
  },
  footer: {
    copyright: '© {year} Varena Agropecuaria Ltda. Todos os direitos reservados.'
  },
  table: {
    mdthisIsASwalAlert: 'Este é um alerta do Swal. Modo: {mode} - URL: {url}'
  },
  appleFarm: {
    title: 'Bem-vindo ao Pomar de Maçã - Varena',
    about: 'A Varena Agropecuária é uma empresa familiar com mais de 30 anos. O pomar é situado em Monte Alegre dos Campos no Rio Grande do Sul. Nosso compromisso é com a produção de maçãs da mais alta qualidade e as melhores práticas agrícolas.',
    apples: 'Na Varena, cultivamos uma variedade de maçãs para todos os gostos. Temos diferentes tipos de maçãs, como Gala e Fuji.',
  },
  fujiApples: {
    title: 'Tudo sobre as Maçãs Fuji',
    intro: 'Aqui está tudo que você precisa saber sobre as doces maçãs Fuji.',
    tips: {
      tip1: 'As maçãs Fuji são uma variedade relativamente nova. Foram cultivadas pela primeira vez no Japão no final dos anos 1930, mas só chegaram ao mercado mundial em 1962.',
      tip2: 'São o resultado de um cruzamento bem-sucedido entre duas variedades americanas, Red Delicious e Virginia Ralls Janet.',
      tip3: 'Conhecidas por sua doçura, as maçãs Fuji têm um dos maiores teores de açúcar entre as maçãs no mercado, com cerca de 14g de açúcar por 100g.',
      tip4: 'Torne as maçãs Fuji doces ainda mais doces usando-as em geleias e chá.',
      tip5: 'Elas se mantêm por três meses na geladeira. Separe as maçãs danificadas para manter as outras mais frescas por mais tempo.',
      tip6: 'A casca da maçã é uma boa fonte de pectina, uma forma de fibra solúvel. A pectina pode ajudar a reduzir o colesterol e os níveis de açúcar no sangue.',
      tip7: 'Desejo por um lanche noturno? Uma maçã é uma ótima escolha, pois tem baixo índice glicêmico e é rica em fibras.',
      tip8: 'Para evitar que as maçãs cortadas fiquem marrons, mergulhe-as em uma mistura de 1 colher de sopa de suco de limão e 1 xícara de água.',
      tip9: 'As maçãs Fuji frescas e crocantes estão no seu auge de doçura e suculência entre abril e outubro.',
      tip10: 'Adicione maçãs Fuji finamente fatiadas a saladas, cereais e coleslaw para dar frescor e crocância.'
    },
    funFacts: {
      title: 'Fatos Curiosos',
      fact1: 'Muitos pensam que as maçãs Fuji receberam esse nome por causa do Monte Fuji, mas o nome vem de Fujisaki, a cidade japonesa onde foram desenvolvidas.',
      fact2: 'Uma Fuji grande pode fornecer 15% da sua vitamina C diária.',
      fact3: 'As Fuji são uma das melhores maçãs para congelar.',
      fact4: 'As Fuji são ótimas para rechear e assar, pois mantêm sua forma durante o cozimento.'
    },
    reference: 'Fonte: taste.com.au'
  },
  galaApples: {
    title: 'Tudo sobre as Maçãs Gala',
    intro: 'Aqui estão 7 fatos que você provavelmente não sabia sobre as Maçãs Gala.',
    facts: {
      fact1: {
        title: 'Origem',
        content: 'A Maçã Gala é uma variedade antiga de Greytown, Nova Zelândia, e é uma seleção feita por JH Kidd do cruzamento entre "Kidss Orange" e "Golden Delicious". É a variedade com maior produção no estado de Washington.'
      },
      fact2: {
        title: 'Uso Principal',
        content: 'Em comparação com outras variedades, a Maçã Gala potencializa seu toque doce quando cozida. Por isso, recomenda-se comer crua ou cozinhar sobremesas doces como uma torta assada.'
      },
      fact3: {
        title: 'Demanda Global',
        content: 'É uma das variedades mais plantadas mundialmente, graças ao seu sabor, polpa suculenta e crocante, bom equilíbrio entre açúcares e acidez.'
      },
      fact4: {
        title: 'Doçura e Sabor',
        content: 'Possui uma doçura equilibrada com um pequeno toque de acidez, com notas de limão, chá branco e groselhas. É uma maçã carnuda.'
      },
      fact5: {
        title: 'Consumo Fácil',
        content: 'Não mancham e não se desfazem, são o lanche ideal para consumir em qualquer lugar, seja após as refeições ou quando você esqueceu sua escova de dentes.'
      },
      fact6: {
        title: 'Hidratação',
        content: 'São muito refrescantes e nos hidratam quase sem percebermos, são perfeitas para nos manter frescos em todos os níveis, físico e intelectual.'
      },
      fact7: {
        title: 'Contribuição Energética',
        content: 'A Maçã Gala tem um alto teor de vitaminas e minerais, bem como carboidratos (especialmente na forma de frutose), que é mais fácil de ser absorvido pelo organismo.'
      }
    },
    reference: 'Fonte: manzanaswashington.com'
  },
  excel: {
    edit: {
      title: 'Editar entrada'
    },
    actions: {
      edit: 'Editar',
      viewHistory: 'Ver Histórico'
    },
    fields: {
      id: 'ID',
      date: 'Data',
      value: 'Valor',
      description: 'Descrição',
      lastModified: 'Última modificação',
      newDescription: 'Nova Descrição',
      existingDescription: 'Descrição Existente',
      selectDescription: 'Selecione uma descrição'
    },
    history: {
      title: 'Histórico de Lançamentos - {descricao}',
      chartTitle: 'Histórico - {timeGrouping}',
      detailed: 'Detalhado',
      monthly: 'Mensal',
      yearly: 'Anual'
    },
    browser: {
      title: "Histórico de Descrição",
      selectTitle: "Selecionar Descrição",
      selectMode: "Modo de Seleção",
      viewHistory: "Ver Histórico"
    }
  },
  common: {
    save: 'Salvar alterações',
    cancel: 'Cancelar',
    backToList: 'Voltar à lista',
    delete: 'Excluir'
  }, 
  valve: {
    stopped: 'Fechado',
    running: 'Aberto',
    start: 'Abrir',
    stop: 'Fechar',
    title: 'Válvulas',
    name: 'Válvula',
    title_valves: 'Válvulas'
  }, colheita: {
    title: 'Entrada de Quantidade de Bins',
    select_date: 'Selecione a data',
    select_setor: 'Selecione o setor',
    select_type: 'Selecione o tipo',
    setor: 'Setor',
    gala: 'Gala',
    fuji: 'Fuji',
    quantity: 'Quantidade',
    add_entry: 'Adicionar Entrada',
    review_submit: 'Revisar e Enviar',
    entry: 'Entrada',
    date: 'Data',
    type: 'Tipo',
    review_title: 'Revisar Entradas',
    submit: 'Enviar',
    cancel: 'Cancelar',
    success: 'Sucesso',
    error: 'Erro',
    submit_success: 'Entradas enviadas com sucesso',
    submit_error: 'Falha ao enviar entradas',
    validation_error: 'Por favor, preencha todos os campos corretamente antes de enviar',
    filter_placeholder: 'Filtrar por Setor ou Tipo',
    apple_variety: 'Variedade de Maçã',
    total_quantity: 'Quantidade Total',
    sector: 'Setor',
    selectSector: 'Selecione o Setor',
    dailyChart: 'Gráfico Diário',
  },
  menu: {
    home: 'Início',
    welcome: 'Bem-vindo',
    irrigationDashboard: {
      title: 'Painel de Irrigação'
    },
    appleVarieties: {
      title: 'Variedades de Maçã',
      gala: 'Maçãs Gala',
      fuji: 'Maçãs Fuji'
    },
    colheita: 'Colheita',
    payloads: 'Payloads',
    map: 'Mapa do Pomar',
    farmonaut: {
      title: 'Farmonaut',
      plantations: 'Plantações',
      fields: 'Campos',
      upload: 'Upload de Campo',
      uploadFile: 'Upload de Arquivo',
      autoFix: 'Upload Auto-Fix',
      validate: 'Validar GeoJSON',
      transform: 'Transformar',
      comparison: 'Comparação',
      assignment: 'Atribuição',
      createFarmonautFields: 'Criar Campos Farmonaut',
      health: 'Verificação de Saúde'
    },
    excelEntryManager: 'Gerenciador de Entradas Excel',
    login: 'Entrar',
    about: 'Sobre Nós',
    playground: {
      title: 'Playground',
      table: 'Tabela',
      datatable: 'Datatable',
      upload: 'Upload',
      fibuInputChange: 'Fibu Input Change',
      segmented: 'Segmentado',
      timeline: 'Timeline',
      setor: 'Setor',
      sampleUsage: 'Sample Usage',
      createPlantation: 'Criar Plantação'
    },
    tests: {
      title: 'Testes',
      i18n: 'Teste I18n'
    },
    test: {
      title: 'Teste',
      formily: 'Formily Test'
    }
  },
  farmonaut: {
    geoJsonEditor: {
      label: 'Geometria GeoJSON',
      hint: 'Formato Polygon: [[[lon, lat], [lon, lat], ...]]',
      valid: 'GeoJSON válido'
    },
    cropCode: {
      label: 'Código da Cultura',
      selectPlaceholder: '-- Selecione o código da cultura --',
      manualLabel: 'Ou insira manualmente',
      manualPlaceholder: 'ex: 35, 165',
      notInList: 'Código não está na lista permitida (será validado no envio)'
    },
    response: {
      copy: 'Copiar',
      error: 'Erro',
      failed: 'Falhou',
      invalid: 'Inválido',
      success: 'Sucesso',
      validResult: 'Válido',
      response: 'Resposta'
    },
    fieldMap: {
      title: 'Mapa do Campo (OpenLayers)'
    },
    plantations: {
      title: 'Carregar Dados da Plantação',
      loadActive: 'Carregar Plantações Ativas',
      loading: 'Carregando...',
      selectPlantation: 'Selecione uma Plantação',
      selectPlaceholder: '-- Selecione uma plantação --',
      details: 'Detalhes da Plantação',
      plantationId: 'ID da Plantação',
      area: 'Área',
      anoPlantado: 'Ano Plantado',
      anoFinal: 'Ano Final',
      active: 'Ativa',
      farmonautId: 'ID Farmonaut',
      registered: 'Registrado',
      notRegistered: 'Não registrado',
      setorDetails: 'Detalhes do Setor',
      setorId: 'ID do Setor',
      setorName: 'Nome do Setor',
      name: 'Nome',
      setorArea: 'Área do Setor',
      center: 'Centro',
      hasGeoJson: 'Possui GeoJSON',
      loadingFarmonaut: 'Carregando dados do campo Farmonaut...',
      farmonautData: 'Dados do Campo Farmonaut',
      cropCode: 'Código da Cultura',
      copyCropCode: 'Copiar',
      fieldId: 'ID do Campo',
      fieldName: 'Nome do Campo',
      fieldArea: 'Área do Campo',
      paymentType: 'Tipo de Pagamento',
      sowingDate: 'Data de Semeadura',
      expired: 'Expirado',
      paused: 'Pausado',
      fullJson: 'Resposta JSON Completa',
      showJson: 'Mostrar JSON Completo',
      hideJson: 'Ocultar JSON',
      errorFarmonaut: 'Erro ao carregar dados Farmonaut',
      sendToFarmonaut: 'Enviar para Farmonaut (Auto-Fix)',
      useInForms: 'Usar nos Formulários',
      infoMessage: 'Clique em "Carregar Plantações Ativas" para buscar as plantações do backend.',
      noGeoJson: 'A plantação selecionada não possui dados GeoJSON no seu Setor'
    },
    fields: {
      title: 'Carregar Campo Farmonaut por ID',
      description: 'Selecione um ID de Campo Farmonaut para carregar e exibir os dados do campo.',
      fieldIdLabel: 'ID do Campo Farmonaut',
      selectField: 'ID do Campo Farmonaut',
      selectPlaceholder: '-- Selecione um campo --',
      loadingFieldIds: 'Carregando IDs dos campos...',
      errorFieldIds: 'Erro ao carregar IDs dos campos',
      loadField: 'Carregar Campo',
      reset: 'Resetar',
      cropCodeSection: 'Código da Cultura',
      copyCropCode: 'Copiar Código da Cultura',
      fieldDetails: 'Detalhes do Campo',
      fieldId: 'ID do Campo',
      fieldName: 'Nome do Campo',
      fieldArea: 'Área do Campo',
      centerCoordinates: 'Coordenadas Centrais',
      paymentType: 'Tipo de Pagamento',
      sowingDate: 'Data de Semeadura',
      fieldStatus: 'Status do Campo',
      expired: 'Expirado',
      expiring: 'Expirando',
      paused: 'Pausado',
      paid: 'Pago',
      healthData: 'Dados de Saúde',
      healthIndicatorLabel: 'Indicador',
      healthIndicatorPlaceholder: 'Selecione o indicador',
      viewGraph: 'Gráfico',
      viewTable: 'Tabela',
      dateColumn: 'Data',
      valueColumn: 'Valor',
      rawJson: 'JSON bruto',
      syncToInternal: 'Sincronizar para BD interna',
      syncToInternalSuccess: 'Sincronização concluída. Tentativas: {attempted}, Ignorados: {skipped}, Erros: {errors}',
      syncErrorNoPlantation: 'Nenhuma plantação vinculada a este campo Farmonaut.',
      updateAllIndices: 'Atualizar todos os índices Farmonaut na BD',
      updateAllIndicesSuccess: 'Importação concluída. Processados: {processed}, Sucesso: {success}, Erros: {errors}',
      updateAllIndicesError: 'Falha ao atualizar os índices.',
      weatherData: 'Dados Meteorológicos',
      yieldData: 'Dados de Rendimento',
      coordinates: 'Coordenadas',
      sensedDays: 'Dias Sensoriados'
    },
    upload: {
      title: 'Upload de Campo',
      fieldName: 'Nome do Campo',
      address: 'Endereço',
      farmerId: 'ID do Agricultor',
      submit: 'Fazer Upload do Campo',
      uploading: 'Fazendo upload...',
      reset: 'Resetar'
    },
    fileUpload: {
      title: 'Upload de Arquivo GeoJSON',
      fieldName: 'Nome do Campo',
      geoJsonFile: 'Arquivo GeoJSON',
      selectFile: 'Selecione um arquivo .geojson ou .json',
      submit: 'Fazer Upload do Arquivo',
      uploading: 'Fazendo upload...',
      reset: 'Resetar'
    },
    autoFix: {
      title: 'Upload com Auto-Fix',
      description: 'Faz upload de um campo e repara automaticamente problemas comuns do GeoJSON (LineString para Polygon, fechamento do anel, etc.)',
      fieldName: 'Nome do Campo',
      address: 'Endereço',
      farmerId: 'ID do Agricultor',
      hint: 'Geometrias LineString serão convertidas automaticamente para Polygon',
      submit: 'Upload com Auto-Fix',
      uploading: 'Fazendo upload...',
      reset: 'Resetar',
      repairedGeoJson: 'GeoJSON Reparado'
    },
    validate: {
      title: 'Validar GeoJSON',
      description: 'Valida o GeoJSON sem fazer upload para o Farmonaut',
      fieldName: 'Nome do Campo',
      cropCode: 'Código da Cultura',
      address: 'Endereço',
      farmerId: 'ID do Agricultor',
      submit: 'Validar',
      validating: 'Validando...',
      reset: 'Resetar'
    },
    transform: {
      title: 'Transformar para Formato Farmonaut',
      description: 'Transforma o GeoJSON para o formato Farmonaut sem fazer upload. Mostra a estrutura de dados transformada.',
      fieldName: 'Nome do Campo',
      address: 'Endereço',
      farmerId: 'ID do Agricultor',
      submit: 'Transformar',
      transforming: 'Transformando...',
      reset: 'Resetar',
      transformedGeoJson: 'GeoJSON Transformado (Formato Farmonaut)',
      copyToClipboard: 'Copiar para Área de Transferência',
      copied: 'Copiado!'
    },
    comparison: {
      title: 'Comparação Campo e Plantação',
      description: 'Compare dados de campo Farmonaut com dados de plantação em um único mapa',
      farmonautFieldId: 'ID do Campo Farmonaut',
      selectFieldPlaceholder: '-- Selecione um campo (opcional) --',
      selectPlantation: 'Selecione a Plantação',
      selectPlantationPlaceholder: '-- Selecione uma plantação --',
      loadPlantations: 'Carregar Plantações',
      loadField: 'Carregar Campo Farmonaut',
      loadFarmonautField: 'Carregar Campo Farmonaut',
      loadPlantation: 'Carregar Plantação',
      loadComparison: 'Carregar Comparação',
      reset: 'Resetar',
      farmonautField: 'Campo Farmonaut (Azul)',
      farmonautFieldBlue: 'Campo Farmonaut (Azul)',
      plantation: 'Plantação (Verde)',
      plantationGreen: 'Plantação (Verde)',
      plantationId: 'ID da Plantação',
      setorName: 'Nome do Setor',
      fieldId: 'ID do Campo',
      fieldName: 'Nome do Campo',
      area: 'Área',
      cropCode: 'Código da Cultura',
      farmonautId: 'ID Farmonaut',
      notRegistered: 'Não registrado',
      assignFarmonautId: 'Atribuir ID Farmonaut',
      assigning: 'Atribuindo...',
      comparisonMap: 'Mapa de Comparação',
      legendFarmonaut: 'Campo Farmonaut',
      legendPlantation: 'Plantação',
      loadingData: 'Carregando dados...',
      loadingFieldIds: 'Carregando IDs dos campos...',
      farmonautFieldError: 'Erro no campo Farmonaut',
      plantationError: 'Erro na plantação',
      assignmentError: 'Erro na atribuição'
    },
    validation: {
      description: 'Validar GeoJSON sem fazer upload para o Farmonaut',
      fieldName: 'Nome do Campo',
      fieldNamePlaceholder: 'Digite o nome do campo',
      cropCode: 'Código da Cultura',
      cropCodePlaceholder: 'ex: 35, 165',
      cropCodeHint: 'O código será validado no envio',
      address: 'Endereço',
      addressPlaceholder: 'Endereço opcional',
      farmerId: 'ID do Agricultor',
      farmerIdPlaceholder: 'ID do agricultor opcional',
      validate: 'Validar',
      reset: 'Resetar'
    },
    createFarmonaut: {
      title: 'Criar Campos Farmonaut a partir de Plantações',
      description: 'Selecione plantações sem ID Farmonaut e crie novos campos Farmonaut a partir dos dados GeoJSON.',
      loading: 'Carregando...',
      refresh: 'Atualizar Plantações',
      withoutId: '{count} plantação(ões) sem ID Farmonaut',
      noPlantations: 'Nenhuma plantação sem ID Farmonaut encontrada.',
      allLinked: 'Todas as plantações ativas foram vinculadas a campos Farmonaut.',
      plantation: 'Plantação',
      created: 'Criado',
      creating: 'Criando...',
      error: 'Erro',
      plantationDetails: 'Detalhes da Plantação',
      geojsonPreview: 'Visualização GeoJSON',
      createField: 'Criar Campo Farmonaut',
      createButton: 'Criar Campo Farmonaut',
      successTitle: 'Campo Farmonaut criado com sucesso!',
      fieldId: 'ID do Campo Farmonaut',
      linked: 'A plantação foi vinculada a este campo Farmonaut.',
      transformDetails: 'Ver detalhes da transformação',
      noGeojson: 'Não – Não é possível criar campo Farmonaut',
      noGeojsonAlert: 'A plantação selecionada não possui dados GeoJSON no setor.',
      noDesignacao: 'O setor da plantação não tem nome (designação). Não é possível criar campo Farmonaut.',
      confirmTitle: 'Criar campo Farmonaut?',
      confirmMessage: 'Criar campo Farmonaut para a Plantação {id}? Setor: {name}, Código da cultura: {cropCode}. Isso criará um novo campo Farmonaut e o vinculará a esta plantação.'
    },
    assignment: {
      title: 'Atribuição Campo e Plantação',
      description: 'Atribua IDs de campos Farmonaut a plantações. Cada campo tem seu próprio mapa para comparação visual.',
      loadingSummaries: 'Carregando resumos de campos e plantações...',
      noFields: 'Nenhum campo Farmonaut encontrado.',
      fieldId: 'ID do Campo',
      assignedTo: 'Atribuído à Plantação {id}',
      notAssigned: 'Não atribuído',
      selectPlantation: '-- Selecione uma plantação --',
      assign: 'Atribuir',
      assigning: 'Atribuindo...',
      successAssigned: 'Atribuído com sucesso!',
      loadingMap: 'Carregando dados do mapa...'
    },
    health: {
      title: 'Verificação de Saúde',
      checkHealth: 'Verificar Saúde',
      checking: 'Verificando...',
      infoMessage: 'Clique em "Verificar Saúde" para verificar se o serviço Farmonaut está funcionando.'
    },
    common: {
      loading: 'Carregando...',
      error: 'Erro',
      noData: 'N/D',
      yes: 'Sim',
      setor: 'Setor',
      plantation: 'Plantação',
      area: 'Área',
      planted: 'Plantado'
    }
  },
  createPlantation: {
    title: 'Criar Nova Plantação',
    setor: 'Setor',
    selectSetor: '-- Selecione um setor --',
    subtipo: 'Subtipo',
    selectSubtipo: '-- Selecione um subtipo --',
    filas: 'Filas',
    arvores: 'Árvores',
    optionalFields: 'Campos Opcionais',
    area: 'Área (ha)',
    plantasPorHa: 'Plantas por Ha',
    anoPlantado: 'Ano Plantado',
    anoFinal: 'Ano Final',
    origem: 'Origem',
    custoPlantacao: 'Custo Plantação',
    formaTreinamento: 'Forma Treinamento',
    cobertura: 'Cobertura',
    submit: 'Criar Plantação',
    creating: 'Criando...',
    reset: 'Redefinir',
    activeWarning: 'Este setor já possui uma plantação ativa. Você não pode criar uma nova.',
    success: 'Plantação criada com sucesso! ID: {id}',
    errorActive: 'Não é possível criar plantação: o setor já possui uma plantação ativa',
    errorGeneric: 'Falha ao criar plantação'
  },
  map: {
    selectMapData: 'Selecione os dados do mapa',
    reloadMapData: 'Recarregar dados do mapa',
    mapData: 'Dados do Mapa',
    testCoordinates: 'Coordenadas de Teste',
    enterGeoJsonCoordinatesArray: 'Digite as coordenadas GeoJSON',
    invalidGeoJsonFormat: 'Formato GeoJSON inválido',
    enterValidGeoJson: 'Digite um formato GeoJSON válido',
    editGeoJson: 'Editar GeoJSON',
    viewGeoJson: 'Visualizar GeoJSON',
    geoJsonForSetor: 'GeoJSON para o setor',
    mapCoordinates: 'Coordenadas do Mapa',
    clickedPosition: 'Posição Clicada',
    longitude: 'Longitude',
    latitude: 'Latitude',
    area: 'Área',
    showAll: 'Mostrar Todos',
    setoresInformation: 'Informações dos Setores',
    showOnMap: 'Mostrar no Mapa',
    addGeoJson: 'Adicionar GeoJSON',
    calculateArea: 'Calcular Área',
    validFeatures: 'Características Válidas',
    testPolygon: 'Polígono de Teste',
    enterGeoJsonForSetor: 'Digite o GeoJSON para o setor',
    loadingSetoresInformation: 'Carregando informações dos setores...',
    viewDetails: 'Ver Detalhes',
    debugInformation: 'Informações de Depuração',
    copyCoordinates: 'Copiar Coordenadas',
    id: 'ID',
    calculateTotalArea: 'Calcular Área Total',
    totalArea: 'Área Total dos Setores Selecionados'
  }
} 